<script>
	export let name;
</script>

<main>
	<h1 class="header">
		GridBrain
		<img src="../assets/img/logo.png" loading="lazy" width="120">
	</h1>
	
	<h2>{name}</h2>
	<p>A full comprehensive, hardware agnostic, digital platform to manage complex micro-grids.</p>

	<h3>At a glance metrics with realtime data.</h3>
	<img src="../assets/img/ss-home.png" loading="lazy" width=800>

	<h3>Mapped site assests with info per unit.</h3>
	<img src="../assets/img/ss-map.png" loading="lazy" width=800>

	<h3>Live data and auto diagnostics from inverters.</h3>
	<img src="../assets/img/ss-inv.png" loading="lazy" width=800>

</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff8000;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	h2 {
		color: hsl(201, 100%, 6%);
		font-size: 2em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}

	.header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px; /* Adjust the gap between the text and the image */
	}


</style>